import { render } from "./Photo.vue?vue&type=template&id=a1327c12&ts=true"
import script from "./Photo.vue?vue&type=script&lang=ts"
export * from "./Photo.vue?vue&type=script&lang=ts"

import "./Photo.vue?vue&type=style&index=0&id=a1327c12&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__